import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import styles from "../../styles/_sections/_constraints/schedule.module.scss";

const Schedule = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  return (
    <div className={styles.container}>
      <div className={styles.dates}>
        <div className={styles.field}>
          <label>From</label>
          <ReactDatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
          />
        </div>

        <div className={styles.field}>
          <label>To</label>
          <ReactDatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
          />
        </div>
      </div>

      <h3>Working Hours</h3>
      <div className={styles.days}>
        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Sunday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Monday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>
        
        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Tuesday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Wednesday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Thursday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Friday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Saturday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
